var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
const SvgClose = (_ref, ref) => {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "18px",
    height: "18px",
    viewBox: "0 0 18 18",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "AB0F8826-CF4D-4DC1-827D-FA02AD9A8A51") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "REIS_Wiregrame-V2",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "REIS_Homepage",
    transform: "translate(-1088.000000, -91.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Search_Bar",
    transform: "translate(803.000000, 76.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-10",
    transform: "translate(285.000000, 15.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Icons/Outline/Information/30",
    fill: "#727472"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9,18 C4.02943725,18 -9.54791801e-15,13.9705627 -9.54791801e-15,9 C-9.54791801e-15,4.02943725 4.02943725,-9.54791801e-15 9,-9.54791801e-15 C13.9705627,-9.54791801e-15 18,4.02943725 18,9 C18,13.9705627 13.9705627,18 9,18 Z",
    id: "Combined-Shape"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group-2",
    transform: "translate(4.000000, 4.000000)",
    stroke: "#FFFFFF",
    strokeLinecap: "square"
  }, /*#__PURE__*/React.createElement("line", {
    x1: 0.526315789,
    y1: 2.10526316,
    x2: 9.28473994,
    y2: 7.94421259,
    id: "Line-7",
    transform: "translate(4.905528, 5.024738) rotate(11.309932) translate(-4.905528, -5.024738) "
  }), /*#__PURE__*/React.createElement("line", {
    x1: 0.526315789,
    y1: 2.10526316,
    x2: 9.28473994,
    y2: 7.94421259,
    id: "Line-7",
    transform: "translate(4.905528, 5.024738) rotate(-78.690068) translate(-4.905528, -5.024738) "
  }))))))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgClose);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/close.3235dacd8c206774259952cf21cd580d.svg";